// eslint-disable-next-line no-use-before-define
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
// eslint-disable-next-line import/no-cycle
import { Progress } from "..";
import useMessageContainerStyles from "../hooks/useMessageContainerStyles";

const useComponentStyles = makeStyles(theme => ({
  text: {
    ...theme.typography.body1,
    marginLeft: "1rem",
    color: theme.palette.secondary.main,
  },
}));

function FetchLoader({ loading, title, size }) {
  const sharedClasses = useMessageContainerStyles();
  const componentClasses = useComponentStyles();
  const classes = { ...sharedClasses, ...componentClasses };
  const { t } = useTranslation();

  const text = title != null ? title : t("loading");

  if (loading === true) {
    return (
      <div className={classes.actionContainer}>
        <Progress show={loading} size={size} />
        <Typography className={classes.text}>{text}</Typography>
      </div>
    );
  }
  return null;
}

FetchLoader.propTypes = {
  loading: PropTypes.bool.isRequired,
  title: PropTypes.string,
  size: PropTypes.number,
};

FetchLoader.defaultProps = {
  size: 36,
  title: null,
};

export default FetchLoader;
